/* Back in Stock — Verobio v2.2.0
 * Envia formulário de contato quando cliente quer ser avisado sobre produto esgotado.
 * Usa iframe oculto para envio (bypassa proteção anti-bot do Shopify).
 * Auto-submete após login (sem clique duplo).
 * Armazena estado no localStorage para feedback visual persistente.
 * v2.2.0: server-side sync via Cloudflare Worker (tag bis:{handle})
 */
(function () {
  if (window.__bisInit) return;
  window.__bisInit = true;

  var STORAGE_KEY = 'verobio_back_in_stock';
  var PENDING_KEY = 'verobio_bis_pending';
  var IFRAME_NAME = 'bis-submit-frame';
  var SUBMIT_TIMEOUT = 8000;

  /* ── Server sync (fire and forget) ───────────────── */
  function syncToServer(action, type, handle) {
    var configEl = document.getElementById('server-sync-config');
    if (!configEl) return;
    var config;
    try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
    if (!config.customer_id) return;
    fetch(config.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shop: config.shop,
        customer_id: config.customer_id,
        action: action,
        type: type,
        handle: handle
      })
    }).catch(function () {});
  }

  /* ── Helpers ──────────────────────────────────────── */
  function getRegistered() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveRegistered(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isRegistered(handle) {
    return getRegistered().indexOf(handle) !== -1;
  }

  function addRegistered(handle) {
    var list = getRegistered();
    if (list.indexOf(handle) === -1) {
      list.push(handle);
      saveRegistered(list);
    }
  }

  /* ── Criar/obter iframe oculto ────────────────────── */
  function getOrCreateIframe() {
    var iframe = document.querySelector('iframe[name="' + IFRAME_NAME + '"]');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.name = IFRAME_NAME;
      iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;left:-9999px;';
      document.body.appendChild(iframe);
    }
    return iframe;
  }

  /* ── Envio do formulário via iframe ───────────────── */
  function submitBackInStock(handle, title, email, btn) {
    var iframe = getOrCreateIframe();

    // Criar form temporário que submete para o iframe
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = '/contact#ContactForm';
    form.target = IFRAME_NAME;
    form.style.display = 'none';
    form.acceptCharset = 'UTF-8';

    // Campos do formulário de contato Shopify
    var fields = {
      'form_type': 'contact',
      'utf8': '✓',
      'contact[email]': email,
      'contact[Nome]': 'Avise-me: ' + handle,
      'contact[Comentário]': 'Handle: ' + handle + ' | Produto: ' + title + ' | Tag: back-in-stock'
    };

    for (var name in fields) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    }

    document.body.appendChild(form);

    // Timeout para detectar falha
    var submitted = false;
    var timer = setTimeout(function () {
      if (!submitted) {
        cleanup();
        showError(btn);
      }
    }, SUBMIT_TIMEOUT);

    // Listener para quando o iframe carregar (sucesso ou erro)
    var onLoad = function () {
      if (submitted) return;
      submitted = true;
      clearTimeout(timer);

      // Verificar se foi para página de captcha ou sucesso
      try {
        var iframeUrl = iframe.contentWindow.location.href;
        var iframeText = iframe.contentDocument.body.innerText || '';

        // Se redirecionou para /contact e não tem "verified", assumimos sucesso
        if (iframeUrl.indexOf('/contact') !== -1 && iframeText.indexOf('verified') === -1) {
          addRegistered(handle);
          markButtonAsRegistered(btn);
          syncToServer('add', 'bis', handle);
        } else if (iframeText.indexOf('verified') !== -1 || iframeText.indexOf('challenge') !== -1) {
          // Shopify mostrou captcha - ainda assim registramos como enviado
          // pois o usuário pode completar o captcha manualmente se abrir a página
          console.warn('[BIS] Captcha detectado, mas registrando como enviado');
          addRegistered(handle);
          markButtonAsRegistered(btn);
          syncToServer('add', 'bis', handle);
        } else {
          showError(btn);
        }
      } catch (e) {
        // Cross-origin error = provavelmente redirecionou (sucesso)
        addRegistered(handle);
        markButtonAsRegistered(btn);
        syncToServer('add', 'bis', handle);
      }

      cleanup();
    };

    var cleanup = function () {
      iframe.removeEventListener('load', onLoad);
      if (form.parentNode) form.parentNode.removeChild(form);
    };

    iframe.addEventListener('load', onLoad);

    // Submeter o form
    form.submit();
  }

  function showError(btn) {
    var span = btn.querySelector('span');
    if (span) span.textContent = 'Erro - tente novamente';
    btn.disabled = false;
    btn.classList.remove('is-loading');
    setTimeout(function () {
      if (span) span.textContent = 'AVISE-ME QUANDO CHEGAR';
    }, 3000);
  }

  /* ── Visual states ─────────────────────────────────── */
  function markButtonAsRegistered(btn) {
    var span = btn.querySelector('span');
    if (span) span.textContent = 'AVISAREMOS VOCÊ';
    btn.disabled = true;
    btn.classList.remove('is-loading');
    btn.classList.add('bis-registered');
  }

  function markButtonAsLoading(btn) {
    var span = btn.querySelector('span');
    if (span) span.textContent = 'Enviando...';
    btn.disabled = true;
    btn.classList.add('is-loading');
  }

  /* ── Auto-submit após login ─────────────────────────── */
  function checkPendingSubmission() {
    var raw = localStorage.getItem(PENDING_KEY);
    if (!raw) return;

    var pending;
    try {
      pending = JSON.parse(raw);
    } catch (e) {
      localStorage.removeItem(PENDING_KEY);
      return;
    }

    var handle = pending.handle;
    if (!handle) {
      localStorage.removeItem(PENDING_KEY);
      return;
    }

    if (isRegistered(handle)) {
      localStorage.removeItem(PENDING_KEY);
      return;
    }

    var btn = document.querySelector('[data-bis-handle="' + handle + '"]');
    if (!btn) {
      localStorage.removeItem(PENDING_KEY);
      return;
    }

    var customerEmail = btn.dataset.bisEmail || '';
    if (!customerEmail) {
      localStorage.removeItem(PENDING_KEY);
      return;
    }

    localStorage.removeItem(PENDING_KEY);
    markButtonAsLoading(btn);
    submitBackInStock(handle, pending.title || '', customerEmail, btn);
  }

  /* ── Inicialização ─────────────────────────────────── */
  function initButtons() {
    document.querySelectorAll('[data-bis-handle]:not([data-bis-bound])').forEach(function (btn) {
      btn.setAttribute('data-bis-bound', '1');
      var handle = btn.dataset.bisHandle;

      if (isRegistered(handle)) {
        markButtonAsRegistered(btn);
        return;
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();

        var customerEmail = btn.dataset.bisEmail || '';
        var productTitle = btn.dataset.bisTitle || '';
        var isLogged = customerEmail !== '';

        if (!isLogged) {
          localStorage.setItem(PENDING_KEY, JSON.stringify({
            handle: handle,
            title: productTitle
          }));
          var returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
          window.location.href = '/account/login?return_url=' + returnUrl;
          return;
        }

        if (isRegistered(handle)) {
          markButtonAsRegistered(btn);
          return;
        }

        markButtonAsLoading(btn);
        submitBackInStock(handle, productTitle, customerEmail, btn);
      });
    });

    checkPendingSubmission();
  }

  /* ── Boot ───────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initButtons);
  } else {
    initButtons();
  }

  /* Re-init ao carregar conteúdo dinâmico (ex: paginação infinita) */
  var observer = new MutationObserver(function (mutations) {
    var hasNew = mutations.some(function (m) {
      return m.addedNodes.length > 0;
    });
    if (hasNew) initButtons();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
